// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.84.1',
  revision: '321ba4a7',
  branch: 'master',
  date: 'Thu, 29 Jan 2026 15:10:54 GMT'
};